import React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import {
  Accordion,
  IconButton,
  Card,
  Typography,
  Tooltip,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const DsokMenuItem = ({
  item,
  disabled,
  onDelete,
  onEdit,
  onCategoryEditClick,
}) => {
  let canDisplayDeleteButton = true;
  const diabledListCodes = ["DINE_IN", "TAKEAWAY"];
  if (diabledListCodes.includes(item?.code)) {
    canDisplayDeleteButton = false;
  }
  const { t, i18n } = useTranslation();
  const title = (() => {
    const raw = item?.title;
    if (typeof raw === "object" && raw !== null) {
      const lang = i18n?.language;
      if (lang && raw[lang]) {
        return String(raw[lang]);
      }
      const first = Object.values(raw)[0];
      return String(first || "");
    }
    return String(raw || "");
  })();
  return (
    <Card sx={{ mb: 1 }}>
      <Accordion expanded={false} square sx={{ borderRadius: 2 }}>
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            px: 3,
            flexDirection: "row-reverse",
            "& .MuiAccordionSummary-content": {
              alignItems: "center",
              justifyContent: "space-between",

              "&.Mui-expanded": {
                margin: "12px 0",
              },
            },
            ".MuiAccordionSummary-expandIconWrapper": {
              color: "text.secondary",
              transform: "none",
              height: 28,
              width: 28,
              alignItems: "center",
              justifyContent: "center",
              mr: 1,

              "&.Mui-expanded": {
                transform: "none",
                color: "primary.main",
                borderColor: "primary.main",
              },

              "& svg": {
                fontSize: "1.25rem",
              },
            },
          }}
        >
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 2 },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.presentation.label")}
            </Typography>
            <Typography variant={"body1"}>{title}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 1 },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.screens.status")}
            </Typography>
            <Typography variant={"body1"}>
              {item.isActive
                ? t("pages.products.active")
                : t("pages.products.disabled")}
            </Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 1 },
              flexShrink: 0,
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.menus.code")}
            </Typography>
            <Typography variant={"body1"}>{item.code}</Typography>
          </Div>
          <Div
            sx={{
              flex: { xs: "0 2 auto", md: 1 },
              px: 1,
            }}
          >
            <Typography
              fontSize={"12px"}
              variant={"h6"}
              color={"text.secondary"}
              mb={0.25}
              sx={{
                display: { xs: "none", md: "block" },
              }}
            >
              {t("pages.presentation.actions")}
            </Typography>
            <Div
              sx={{
                display: "flex",
                flex: { direction: "row", flexWrap: "wrap" },
                minWidth: 70,
              }}
            >
              <Div>
                <IconButton
                  size="big"
                  variant={"contained"}
                  disabled={disabled}
                  onClick={onEdit}
                >
                  <Tooltip title={t("buttons.edit")} placement="top-start">
                    <EditIcon />
                  </Tooltip>
                </IconButton>
                <IconButton
                  size="small"
                  variant={"contained"}
                  disabled={disabled || !canDisplayDeleteButton}
                  onClick={() => onDelete(item)}
                >
                  <Tooltip title={t("buttons.delete")} placement="top-start">
                    <DeleteForeverIcon />
                  </Tooltip>
                </IconButton>
              </Div>
            </Div>
          </Div>
        </AccordionSummary>
      </Accordion>
    </Card>
  );
};
/* Todo item prop define */
export default DsokMenuItem;
